import { defineStore } from 'pinia'
import _ from 'lodash'

export const useGlobalStore = defineStore('global', {
	state: () => {
		return {
			mobile: false,
			activation: null,
			countries: [],
			platforms: [],
			modal: {
				name: null,
				payload: null,
			},
			availablePlatforms: [
				{
					name: 'Playstation',
					slug: 'playstation',
					fa_icon: 'fab fa-playstation',
					icon: null,
					link: 'https://store.playstation.com/product/JP0576-PPSA19359_00-PS5FFCOTWSPECIAL',
				},
				{
					name: 'Xbox',
					slug: 'xbox',
					fa_icon: 'fab fa-xbox',
					icon: null,
					link: 'https://www.xbox.com/games/store/餓狼伝説-city-of-the-wolves-special-edition/9nppw057hbdw',
				},
				{
					name: 'Steam',
					slug: 'steam',
					fa_icon: 'fab fa-steam',
					icon: null,
					link: 'https://store.steampowered.com/app/2492040/FATAL_FURY_City_of_the_Wolves',
				},
				{
					name: 'Epic Games',
					slug: 'epic',
					fa_icon: null,
					icon: 'https://cdn.fatalfury.club/preorder-platform/images/logos/epic-games.svg',
					link: 'https://store.epicgames.com/p/garou-city-of-the-wolves-556c5a',
				},
			],
			socials: [
				{
					name: 'Twitter',
					slug: 'twitter',
					icon: 'fab fa-x-twitter',
					link: 'https://x.com/fatalfury_pr',
				},
				{
					name: 'Instagram',
					slug: 'instagram',
					icon: 'fab fa-instagram',
					link: 'https://www.instagram.com/fatalfury_pr',
				},
				{
					name: 'Discord',
					slug: 'discord',
					icon: 'fab fa-discord',
					link: 'https://discord.gg/fatalfury',
				},
			],
		}
	},
	getters: {
		//
	},
	actions: {
		toggleMobile(delta) {
			delta != null ? (this.mobile = delta) : (this.mobile = !this.mobile)
		},
		setup() {
			this.getCountries()
			this.getPlatforms()
			this.getActivation()
		},
		//
		getCountries() {
			return axios
				.get('/api/countries')
				.then((countries) => {
					this.countries = countries.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getPlatforms() {
			return axios
				.get('/api/platforms')
				.then((platforms) => {
					this.platforms = platforms.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		getActivation(slug) {
			this.activation = JSON.parse(document.body.getAttribute('data-activation'))
		},
		openModal(modal) {
			this.modal = {
				name: modal,
				payload: null,
			}
			document.body.classList.add('overflow-hidden')
		},
		setModal(modal) {
			this.modal = {
				name: modal[0],
				payload: modal[1],
			}
		},
		closeModal() {
			this.modal = {
				name: null,
				payload: null,
			}
			document.body.classList.remove('overflow-hidden')
		},
	},
})
